import React from 'react'

import './horizontal-list.scss'
import { useHistory } from 'react-router-dom'
import MyRouterUtil from "utils/MyRouterUtil";

const HorizontalList = props => {
  const { item, data } = props

  const history = useHistory()

  const toGoodsInfo = ({goodsType, id}) => {
    MyRouterUtil.build({history})
        .toGoodsInfo({goodsType, id})
  }

  return (
    <div className='horizontal-list'>
      <div className='horizontal-list-wrapper'>
        {data?.length && data.map((datum, i) => item(datum, i, toGoodsInfo))}
      </div>
    </div>
  )
}

export default HorizontalList
